import { Pipe, PipeTransform } from '@angular/core';
import { IMenu } from '@carm/base-layout/main/main-header/models/menu.model';
import { Observable } from 'rxjs';
import { AccessControlService } from '../../_core/access-control-mgt/services/access-control.service';

@Pipe({name: 'applyAcl'})
export class ApplyAclPipe implements PipeTransform {

  constructor(private accessControlService: AccessControlService) {
  }

  transform(values: IMenu[]): Observable<IMenu[]> {
    return this.accessControlService.applyAcl(values);
  }
}
